import { render, staticRenderFns } from "./TheFullScreenBtn.vue?vue&type=template&id=472b4dda"
import script from "./TheFullScreenBtn.vue?vue&type=script&lang=js"
export * from "./TheFullScreenBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports